<!--
 * Created by JackCui on 2021/12/23
 -->

<script>
  import { initLine } from '../../../utils/share'
  import emitter from '../../../utils/emitter'
  import defaultValue from '../../../utils/default-value'
  import { isEmpty, cloneDeep, isFunction } from 'lodash-es'
  import pageText from './i18n'
  let serialNumber = 10000

  export default {
    name: 'master-relation',
    mixins: [emitter, defaultValue],
    props: {
      node: Object
    },
    inject: ['formData', 'subMap', 'store', 'pageType'],
    provide () {
      return {
        subData: this.subData
      }
    },
    computed: {
      curSub () {
        return this.subMap ? this.subMap[this.node.apiName] : {}
      },
      subData () {
        return this.curSub?.data || []
      },
      rules () {
        return this.node?.rule || this.node?.rules?.[this.node.layoutApiName] || []
      }
    },
    data () {
      return {
        itemData: null,
        tableRef: null
      }
    },
    methods: {
      // 获取tableRef
      _getTableProp (key = '') {
        if (this.tableRef === null) {
          this.tableRef = this.childVm('table-render')
        }
        return key === '' ? this.tableRef : this.tableRef[key]
      },
      updatePageByIndex () {
        this._getTableProp().updatePageByIndex(...arguments)
      },
      handleBatchAddLine (fieldMap, rows = [], cb) {
        const _rows = []
        if (rows.length > 0) {
          rows.forEach(row => {
            _rows.push(this.handleAddLine(fieldMap, row, cb))
          })
        } else {
          _rows.push(this.handleAddLine(fieldMap))
        }
        if (isFunction(cb)) {
          cb(this.subData, _rows)
        } else {
          this.subData.unshift(..._rows)
        }
        this.$nextTick(() => {
          _rows.forEach(v => {
            this.initRelatePages(fieldMap, this.node.subObjectParamName, v)
          })
        })
        this.store?.validateField && this.store.validateField(`${this.node.apiName}`)
      },
      // 新增行
      handleAddLine (fieldMap, row = {}) {
        const {apiName} = this.node
        if (!isEmpty(row) || !this.itemData) {
          this.itemData = initLine(fieldMap, row)
        }
        const _item = cloneDeep(this.itemData)
        const key = this._getTableProp('rowKey')
        if (!_item[key]) {
          _item[key] = `${apiName}_CREATE_${++serialNumber}`
        }
        return _item
      },
      // 删除行
      handleDelLine (row) {
        this._delLine(row, true)
        this._updateSubData({
          apiName: this.node.apiName,
          rows: [row],
          type: 'del',
          rowKey: this._getTableProp('rowKey')
        })
      },
      handleAddColumn (position, items) {
        const addColumn = this._getTableProp('addColumn')
        addColumn && addColumn(position, items)
      },
      handleDelColumn (columnId) {
        const delColumn = this._getTableProp('delColumn')
        delColumn && delColumn(columnId)
      },
      _delLine (row, isNeed = false) {
        const tableRef = this._getTableProp()
        let itemIndex = this.subData.findIndex(item => row[tableRef.rowKey] === item[tableRef.rowKey])
        this.subData.splice(itemIndex, 1)
        if (isNeed) {
          let selectItem = tableRef.tableSelection.find(item => row[tableRef.rowKey] === item[tableRef.rowKey])
          selectItem && tableRef.$refs.syTable.$refs.table.toggleRowSelection(selectItem, false)
        }
      },
      // 批量删除
      handleBatchDelete () {
        const select = this.getSelection()
        const tableRef = this._getTableProp()
        if (select.length === 0) {
          this.$message({type: 'error', message: pageText.SelectLeastOnePieceOfData})
          return
        }
        select.forEach(item => {
          this._delLine(item)
          tableRef.$refs.syTable.$refs.table.toggleRowSelection(item, false)
        })
        this._updateSubData({
          apiName: this.node.apiName,
          rows: select,
          type: 'del',
          rowKey: tableRef.rowKey
        })
      },
      // 删除行
      getSelection () {
        return this._getTableProp('tableSelection')
      },
      toggleSelection (row, flag) {
        this._getTableProp().toggleSelection(row, flag)
      },
      toggleRowExpansion (row, flag) {
        this._getTableProp().toggleRowExpansion(row, flag)
      },
      _updateSubData ({type, rows, apiName, rowKey}) {
        const dels = this.curSub.dels
        if (type === 'del') {
          dels.push(...rows.filter(v => {
            return v[rowKey] && !(String(v[rowKey])).includes(`${apiName}_CREATE`)
          }))
        }
        this.store?.validateField && this.store.validateField(`${this.node.apiName}`)
      }
    },
    render (h) {
      return (
        <div>
          <render className='master-relation' viewContent={this.node.viewContent}/>
          {
            // 从对象和form-item分开解决 is-required class导致全部行都有黄色背景
          }
          <sy-form-item
            {...{
              props: {
                hideLabel: true,
                banner: false,
                span: '0',
                pageType: this.pageType
              }
            }}
            prop={this.node.apiName}
            rules={this.rules}
          />
        </div>
      )
    },
    mounted () {
      const {objectApiName} = this.node
      this.store.saveRef(`masterRelation_${objectApiName}`, this)
    }
  }
</script>

<style scoped>
.master-relation{
  margin: 0 -16px;
}
</style>
